
export default {
  name: "SellerCard",
  data() {
    return {
      updatedAt: null,
    };
  },
  props: {
    seller: {
      type: Object,
      default: () => {},
    },
    productName: {
      type: String,
      default: null,
    },
    isCheapest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    calculateDate(dateStr) {
      return this.$helper.calculateDateDifference(dateStr);
    },
    setUpdatedAt() {
      this.updatedAt = this.calculateDate(this.seller.updatedAt);
    },
  },
  computed: {
    sellerUrl() {
      return this.$helper.addUtmSource(this.seller.url, {
        utm_media: this.productName,
      });
    },
    marketplaceColor() {
      switch (this.seller?.marketplace) {
        case "trendyol":
          return "#f26623";
        case "hepsiburada":
          return "#cf540d";
        case "n11":
          return "#5d3ebc";
        default:
          return "gold";
      }
    },
    sellerLogo() {
      const path = "/images/sellers/logo";
      const name = this.seller.marketplace
        ? `${this.seller.marketplace}.png`
        : this.seller.logo;
      return `${path}/${name}`;
    },
    sellerName() {
      return this.seller?.marketplace
        ? this.seller.storeName ?? this.seller.name
        : this.seller.name;
    },
  },
  mounted() {
    this.setUpdatedAt();
    setInterval(() => {
      this.setUpdatedAt();
    }, 1000);
  },
};
